import { gql } from '@/__generated__';

const GET_DEVICE_PROFILE_ALERTS = gql(`#graphql
  query DeviceProfile_GetDeviceProfileAlerts($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      alerts {
        activeConfigurations {
          id
          deviceId
          metric
          startAt
          ok {
            id
            ...AlertStateInfoboxFragment
          }
          info {
            id
            ...AlertStateInfoboxFragment
          } 
          warning {
            id
            ...AlertStateInfoboxFragment
          }
          critical {
            id
            ...AlertStateInfoboxFragment
          }
        }
        id
      }
    }
  }

  fragment AlertStateInfoboxFragment on AlertConfigurationByState {
    id
    comparisonType
    thresholdMin
    thresholdMax
    thresholdValue
    notificationDelaySec
    metricUnit
  }

`);

export default GET_DEVICE_PROFILE_ALERTS;
